import script from "./AppContacts.vue?vue&type=script&setup=true&lang=js"
export * from "./AppContacts.vue?vue&type=script&setup=true&lang=js"

import "./AppContacts.vue?vue&type=style&index=0&id=117c93c8&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-117c93c8"]])

export default __exports__